// Resolve a per-language content value with fallback to the base (default-language) string.
// Never returns empty when a base value exists; empty/missing translations fall back to base.
export function resolveI18n(
  i18nMap: Record<string, string> | undefined | null,
  fallback: string | undefined | null,
  language: string,
): string {
  const value = i18nMap?.[language]
  if (typeof value === 'string' && value.trim() !== '') {
    return value
  }
  return fallback ?? ''
}
